/* global jQuery anime */

// eslint-disable-next-line no-unused-vars
function animationInit() {}
// eslint-disable-next-line no-unused-vars
function animationUnload() {}

;(function($) {
	// eslint-disable-next-line no-func-assign
	animationInit = function() {
		businessAnimation()
	}

	/**
	 * businesses animated logo
	 */
	function businessAnimation() {
		$('.v-pageHead__anime-logo').each(function() {
			let self = this
			let id = $(this).attr('id')
			let animeLogo = anime.timeline({
				easing: 'easeInOutSine',
				duration: 750,
				loop: 1,
				autoplay: true,
				delay: function(el, i) {
					return i * 100
				},
				begin: function(anim) {
					$(self).addClass('is-playing')
				}
			})

			animeLogo.add({
				targets: `#${id} path`,
				strokeDashoffset: [anime.setDashoffset, 0]
			})

			animeLogo.add({
				duration: 500,
				targets: `#${id} use`,
				fillOpacity: 1,
				delay: function(el, i) {
					return i * 20
				}
			})

			animeLogo.play();
		})
	}

	// eslint-disable-next-line no-func-assign
	animationUnload = function() {
		// businesses section
		$('.v-pageHead__anime-logo').off('mouseenter mouseleave')
		$(window).off('touchstart.businessAnimation')
	}
})(jQuery)
